var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full sm:my-[80px] my-10"},[_c('div',{staticClass:"2xl:max-w-[1630px] xl:max-w-[1260px] mx-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }